import { h, mount } from '../lib/dom.js';
import { currentUser, logout } from '../lib/auth.js';
import { navigate, currentPath } from '../lib/router.js';
import { toast } from '../lib/ui.js';

const SIDEBAR_KEY = 'yks.sidebarOpen';
function isSidebarOpen() {
  try {
    const stored = localStorage.getItem(SIDEBAR_KEY);
    if (stored === null) return window.innerWidth >= 901; // desktop → default açık
    return stored === '1';
  } catch { return true; }
}
function setSidebarOpen(open) {
  try { localStorage.setItem(SIDEBAR_KEY, open ? '1' : '0'); } catch {}
}

const STUDENT_NAV = [
  { to: '/student',          label: 'Bugün',         icon: '◐', section: 'Panel' },
  { to: '/student/week',     label: 'Bu Hafta',      icon: '☰', section: 'Panel' },
  { to: '/student/weeks',    label: 'Haftalar',      icon: '❒', section: 'Panel' },
  { to: '/student/my-notes', label: 'Notlarım',      icon: '✎', section: 'Notlar' },
  { to: '/student/notes',    label: 'Koç Notları',   icon: '✏︎', section: 'Notlar' },
  { to: '/countdown',        label: 'YKS Sayacı',    icon: '◷', section: 'Sınav' },
];
const COACH_NAV = [
  { to: '/coach',                label: 'Genel Bakış',       icon: '◈', section: 'Panel' },
  { to: '/coach/weeks',          label: 'Haftalar',          icon: '☰', section: 'Planlama' },
  { to: '/coach/subjects',       label: 'Dersler & Konular', icon: '✎', section: 'Planlama' },
  { to: '/coach/sources',        label: 'Kaynaklar',         icon: '📚', section: 'Planlama' },
  { to: '/coach/reports',        label: 'Rapor',             icon: '📊', section: 'Analiz' },
  { to: '/coach/notes',          label: 'Koç Notlarım',      icon: '✏︎', section: 'Notlar' },
  { to: '/coach/student-notes',  label: 'Öğrenci Notları',   icon: '❒', section: 'Notlar' },
  { to: '/countdown',            label: 'YKS Sayacı',        icon: '◷', section: 'Sınav' },
];

export function renderShell(children) {
  const user = currentUser();
  const isCoach = user?.role === 'coach';
  const isStudent = user?.role === 'student';
  const navItems = isCoach ? COACH_NAV : (isStudent ? STUDENT_NAV : []);

  const sidebar = h('aside', { class: 'app-sidebar sidebar', id: 'app-sidebar' });
  const groups = new Map();
  navItems.forEach(item => {
    const sec = item.section || 'Menü';
    if (!groups.has(sec)) groups.set(sec, []);
    groups.get(sec).push(item);
  });
  groups.forEach((items, sec) => {
    const g = h('div', { class: 'sidebar-section' });
    g.appendChild(h('div', { class: 'sidebar-section-title' }, sec));
    items.forEach(it => {
      const active = currentPath().split('?')[0] === it.to;
      g.appendChild(h('a', {
        href: `#${it.to}`,
        class: 'nav-item' + (active ? ' active' : ''),
      }, h('span', { style: { width: 16, textAlign: 'center', opacity: 0.7 } }, it.icon), it.label));
    });
    sidebar.appendChild(g);
  });

  const toggleBtn = h('button', {
    class: 'btn btn-ghost btn-icon menu-toggle',
    'aria-label': 'Kenar menüyü aç/kapat',
    'aria-controls': 'app-sidebar',
  }, '≡');

  const topbar = h('header', { class: 'app-topbar topbar' },
    toggleBtn,
    h('div', { class: 'brand' }, 'Sessiz Kütüphane', h('small', {}, 'Koçluk & Plan')),
    h('div', { class: 'topbar-spacer' }),
    user ? h('div', { class: 'topbar-user' },
      h('span', { class: `role-chip ${user.role}` }, user.role === 'coach' ? 'Koç' : 'Öğrenci'),
      h('span', { class: 'user-name' }, user.name),
      h('button', {
        class: 'btn btn-ghost btn-sm btn-logout',
        title: 'Oturumu kapat',
        'aria-label': 'Oturumu kapat',
        onclick: async () => { await logout(); toast('Oturum kapatıldı'); navigate('/login'); },
      }, 'Çıkış'),
    ) : null,
  );

  const backdrop = h('div', { class: 'sidebar-backdrop' });
  const main = h('main', { class: 'app-main' },
    h('div', { class: 'main' }, children instanceof Node ? children : h('div')),
  );
  const shell = h('div', { class: 'app' }, topbar, sidebar, backdrop, main);

  // Now wire behavior with shell already created
  const applyState = (open) => {
    shell.classList.toggle('sidebar-open', open);
    toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
  const toggleOpen = () => {
    const now = !shell.classList.contains('sidebar-open');
    setSidebarOpen(now);
    applyState(now);
  };
  toggleBtn.addEventListener('click', toggleOpen);
  backdrop.addEventListener('click', () => { setSidebarOpen(false); applyState(false); });
  sidebar.addEventListener('click', (e) => {
    if (e.target.closest('.nav-item') && window.innerWidth <= 900) {
      setSidebarOpen(false); applyState(false);
    }
  });
  applyState(isSidebarOpen());
  return shell;
}

export function pageHead(title, subtitle, ...actions) {
  return h('header', { class: 'page-head row-between row-wrap' },
    h('div', {},
      h('h1', {}, title),
      subtitle ? h('p', { class: 'muted' }, subtitle) : null,
    ),
    actions.length ? h('div', { class: 'row row-wrap' }, ...actions) : null,
  );
}

export function empty(msg, sub = '') {
  return h('div', { class: 'empty' },
    h('h4', {}, msg),
    sub ? h('p', { class: 'subtle' }, sub) : null,
  );
}

export function loading() {
  return h('div', { class: 'empty' }, h('p', { class: 'subtle' }, 'Yükleniyor…'));
}
